import { defineMessages } from 'react-intl';

export const messages: {
	emailLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	inboxLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	sentLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	forwardedLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	externalPersonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	timestampLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	emailLabel: {
		id: 'search-federated-result.email.label',
		defaultMessage: 'Email',
		description:
			'The text is shown as a category label on federated email search result cards in the search page results list.',
	},
	inboxLabel: {
		id: 'search-federated-result.inbox.label',
		defaultMessage: 'Inbox',
		description:
			'The text is shown as a metadata label on a federated email search result card indicating the email was found in the inbox folder.',
	},
	sentLabel: {
		id: 'search-federated-result.sent.label',
		defaultMessage: '{person} sent',
		description:
			"The text is shown as a metadata label on a federated email search result card indicating the email was sent by someone. The placeholder {person} will be substituted with the sender's name.",
	},
	forwardedLabel: {
		id: 'search-federated-result.forwarded.label',
		defaultMessage: '{person} forwarded',
		description:
			"The text is shown as a metadata label on a federated email search result card indicating the email was forwarded by someone. The placeholder {person} will be substituted with the forwarder's name.",
	},
	externalPersonLabel: {
		id: 'search-federated-result.external-person.label',
		defaultMessage: 'External person',
		description: 'Label for external person in the search result title',
	},
	timestampLabel: {
		id: 'search-federated-result.timestamp.label',
		// eslint-disable-next-line @atlassian/i18n/no-useless-message
		defaultMessage: '{formattedDate}',
		description: 'Label for the timestamp to include only the date',
	},
});
